import ProjectSession from "../../../../../core/model2/project/project-session";
import {QuickAddItemType} from "../../../../../app/quick-add/@types";
import {menuAdd_initReports} from "./report";
import {PopoverMenuItemType} from "../../../../../core/gd-components/popover-menu/popover-menu/const";
import {TagType} from "../../../../../core/model2/tag/const";
import {Feature} from "../../../../../core/gd/access-control/feature-access/const";

export default function navigationMenuAdd_initMore(options:Options, disabled:boolean, project?:ProjectSession) {

    const onAddTag = () => {
        gd.openNew(QuickAddItemType.TAG, {
            company     : gd.companyId,
            projectId   : project?.id,
            type        : project ? TagType.PROJECT : undefined
        })
        gd.layout.popovers.closeAll()
    }

    const onAddDatabse = () => {
        gd.openNew(QuickAddItemType.DATABASE, {
            projectId   : project?.id,
        })
        gd.layout.popovers.closeAll()

    }

    const onAddSupportSystem = () => {

        if (!gd.company.license.isBusiness) {
            gd.layout.popovers.closeAll()
            gd.modals.other.upgrade(Feature.SUPPORT_TICKET)
            return
        }

        gd.openNew(QuickAddItemType.SUPPORT_SYSTEM, {
            projectId   : project?.id,
        })
        gd.layout.popovers.closeAll()
    }

    const onAddSection = () => {
        gd.openNew(QuickAddItemType.SECTION, {
            projectId: project?.workspace?.project.id,
        })
        gd.layout.popovers.closeAll()
    }


    const moreOptions : Options = [
        {
            icon        : 'i5-tag',
            label       : 'Tag',
            disabled    : disabled,
            onClick     : onAddTag
        },
        {
            icon        : 'ii5-support',
            label       : 'Tickets',
            disabled    : disabled || gd.company.license.isBusiness && !gd.modules.supportTicket.enabled,
            onClick     : onAddSupportSystem
        },
        {
            icon        : 'ii5-database',
            label       : 'Database',
            disabled    : disabled,
            onClick     : onAddDatabse
        }
    ]

    menuAdd_initReports(moreOptions, disabled, project)

    moreOptions.push({
        icon        : "i5-section",
        label       : "Menu Section",
        hint        : 'Create a separate menu section in this workspace to organize projects, folders and views.',
        disabled    : !project,
        onClick     : onAddSection
    })

    options.push({
        type        : PopoverMenuItemType.SUBMENU,
        icon        : 'i5-more',
        label       : 'More',
        disabled    : disabled,
        // onClick     : onAddPage,
        options     : moreOptions
    })










}
